export default __webpack_public_path__ + "490189cf7df8cbfe39f9e12127e522b3.svg";